var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiscord2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204.034,
    height: 156.984,
    viewBox: "0 0 204.034 156.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0.1;}.c{filter:url(#c);}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 204.034,
    height: 156.984,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 61.033,
    y: 46.193,
    width: 82.275,
    height: 64.598,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232.645,115.34a161.2,161.2,0,0,0-40.237-12.393,114.29,114.29,0,0,0-5.154,10.49,150.71,150.71,0,0,0-44.594,0,111.619,111.619,0,0,0-5.215-10.49,160.6,160.6,0,0,0-40.269,12.424c-25.465,37.717-32.368,74.5-28.916,110.758a162.126,162.126,0,0,0,49.349,24.787,120,120,0,0,0,10.569-17.062,104.685,104.685,0,0,1-16.644-7.94c1.4-1.013,2.761-2.072,4.08-3.163,32.091,14.712,66.961,14.712,98.667,0,1.336,1.091,2.7,2.15,4.08,3.163a104.443,104.443,0,0,1-16.673,7.955,119.453,119.453,0,0,0,10.568,17.062,161.795,161.795,0,0,0,49.38-24.8C265.688,184.095,254.72,147.653,232.645,115.34ZM132.551,203.83c-9.634,0-17.534-8.816-17.534-19.551s7.731-19.564,17.534-19.564,17.7,8.814,17.534,19.564C150.1,195.014,142.354,203.83,132.551,203.83Zm64.8,0c-9.634,0-17.534-8.816-17.534-19.551s7.733-19.564,17.534-19.564,17.7,8.814,17.534,19.564C214.881,195.014,207.15,203.83,197.347,203.83Z",
    transform: "translate(-62.93 -98.45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M129.5,107.6a60.565,60.565,0,0,0-15.117-4.656,42.943,42.943,0,0,0-1.936,3.941,56.623,56.623,0,0,0-16.754,0,41.938,41.938,0,0,0-1.959-3.941,60.337,60.337,0,0,0-15.129,4.668c-9.567,14.17-12.161,27.99-10.864,41.612a60.911,60.911,0,0,0,18.541,9.313,45.083,45.083,0,0,0,3.971-6.41A39.329,39.329,0,0,1,84,149.146c.524-.38,1.037-.778,1.533-1.188a43.508,43.508,0,0,0,37.07,0c.5.41,1.014.808,1.533,1.188a39.238,39.238,0,0,1-6.264,2.989,44.88,44.88,0,0,0,3.97,6.41,60.787,60.787,0,0,0,18.552-9.318C141.918,133.435,137.8,119.743,129.5,107.6ZM91.9,140.849c-3.619,0-6.587-3.312-6.587-7.345s2.9-7.35,6.587-7.35,6.651,3.311,6.588,7.35C98.491,137.537,95.581,140.849,91.9,140.849Zm24.344,0c-3.619,0-6.588-3.312-6.588-7.345s2.905-7.35,6.588-7.35,6.651,3.311,6.588,7.35C122.829,137.537,119.925,140.849,116.242,140.849Z",
    transform: "translate(-1.9 -52.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscord2);
export default __webpack_public_path__ + "static/media/icon_discord_2.1b97371efcbadb894e1a3b0d0423fd57.svg";
export { ForwardRef as ReactComponent };